import { useState } from 'react'
import ConnectedAccountRow from '@/settings/components/ConnectedAccountRow'
import ConnectedAccountsLoadingRow from '@/settings/components/ConnectedAccountsLoadingRow'
import ConnectRedirectDialog from '@/settings/components/ConnectRedirectDialog'
import ProviderOptionRow from '@/settings/components/ProviderOptionRow'
import SectionHeader from '@/settings/components/SectionHeader'
import SectionIntro from '@/settings/components/SectionIntro'
import useConnectedAccounts from '@/settings/hooks/useConnectedAccounts'
import { kExternalStorageProviderDisplayName, kIsExternalStorageProviderEnabled } from '@/constants/constants-external-storage'
import { DisconnectDialog } from '@/user_files/external-storage/components/DisconnectDialog'

export default function ConnectedAccounts() {
  const [disconnectDialogOpen, setDisconnectDialogOpen] = useState(false)
  const {
    accountsLoadError,
    confirmingProvider,
    handleConfirmConnect,
    handleDisconnect,
    handleProviderConnect,
    handleReconnect,
    isInitialLoading,
    loadingProvider,
    providers,
    setConfirmingProvider,
    visibleAccount,
  } = useConnectedAccounts()

  return (
    <div className="flex flex-col overflow-hidden rounded-lg border border-brand-neutral-200 bg-white">
      <SectionHeader />
      {isInitialLoading ? (
        <ConnectedAccountsLoadingRow />
      ) : visibleAccount ? (
        <ConnectedAccountRow
          account={visibleAccount}
          onDisconnect={() => setDisconnectDialogOpen(true)}
          onReconnect={handleReconnect}
          loading={loadingProvider === visibleAccount.provider}
        />
      ) : (
        <>
          <SectionIntro error={accountsLoadError} />
          <div aria-label="Document management system" className="flex flex-col">
            {providers.map((providerKey) => {
              const providerEnabled = kIsExternalStorageProviderEnabled(providerKey)

              return (
                <ProviderOptionRow
                  key={providerKey}
                  providerKey={providerKey}
                  onSelect={() => {
                    if (providerEnabled) handleProviderConnect(providerKey)
                  }}
                  disabled={!providerEnabled || Boolean(loadingProvider) || accountsLoadError}
                  comingSoon={!providerEnabled}
                />
              )
            })}
          </div>
        </>
      )}

      <ConnectRedirectDialog
        provider={confirmingProvider}
        open={confirmingProvider != null}
        loading={loadingProvider === confirmingProvider}
        onOpenChange={(open) => {
          if (!open && !loadingProvider) setConfirmingProvider(null)
        }}
        onContinue={handleConfirmConnect}
      />

      {visibleAccount && (
        <DisconnectDialog
          open={disconnectDialogOpen}
          loading={loadingProvider === visibleAccount.provider}
          title={`Disconnect ${kExternalStorageProviderDisplayName[visibleAccount.provider]}?`}
          description={`This will disconnect your ${
            kExternalStorageProviderDisplayName[visibleAccount.provider]
          } account and stop syncing folders for all matters. You can reconnect it later from Settings.`}
          onOpenChange={setDisconnectDialogOpen}
          onConfirm={async () => {
            const disconnected = await handleDisconnect()
            if (disconnected) setDisconnectDialogOpen(false)
          }}
        />
      )}
    </div>
  )
}
